import { makeStyles } from '@mui/styles';
import { appColors, backgroundColors } from 'src/consts/app-config';

export const useStyles = makeStyles({
    notificationContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    notificationText: {
        color: appColors.white,
    },
});
